import { render, staticRenderFns } from "./WeeklyNav.vue?vue&type=template&id=3c9f4a0f"
import script from "./WeeklyNav.vue?vue&type=script&lang=js"
export * from "./WeeklyNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports